import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import DBService from '../../service/DBService';
import { Link } from 'react-router-dom';

class MixLow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
        };
    }

    getLength(result){
        return (result.length > 3 ? 3 : result.length)
    }

    componentDidMount() {
        DBService.getNewLow()
            .then(result => {
                result = result.data;
                console.log('getNewLow', result);
                let filteredData = [];
                if (result.length > 0) {
                    for (var i = 0; i < this.getLength(result); i++) {
                        result[i].url = '/stocks/newLow';
                        result[i].signal = 'New Low';
                        filteredData.push(result[i]);
                    }
                }

                DBService.getNew52Low()
                    .then(result => {
                        result = result.data;
                        console.log('getNew52Low', result);
                        if (result.length > 0) {
                            for (var i = 0; i < this.getLength(result); i++) {
                                result[i].url = '/stocks/new52Low';
                                result[i].signal = '52 Week Low';
                                filteredData.push(result[i]);
                            }
                        }

                        DBService.getOverSold()
                            .then(result => {
                                result = result.data;
                                console.log('getOverSold', result);
                                if (result.length > 0) {
                                    for (var i = 0; i < this.getLength(result); i++) {
                                        result[i].url = '/stocks/overSold';
                                        result[i].signal = 'Over Sold';
                                        filteredData.push(result[i]);
                                    }
                                }

                                DBService.getMostVolatile()
                                .then(result => {
                                    result = result.data;
                                    console.log('getMostVolatile', result);
                                    if (result.length > 0) {
                                        for (var i = 0; i < this.getLength(result); i++) {
                                            result[i].url = '/stocks/mostVolatile';
                                            result[i].signal = 'Most Volatile';
                                            filteredData.push(result[i]);
                                        }
                                    }
    
                                    this.setState({ list: filteredData });
                                })
                                .catch((error) => {
                                    console.log(error);
                                });
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    getColor(value){
        return value >= 0 ? 'green' : 'red';
    }

    renderRow(listValue) {
        if (listValue !== undefined && listValue.symbol !== undefined) {
            let url = '/chart/' + listValue.symbol;
            let color = this.getColor(listValue.changesPercentage);
            return (
                <tr style={{ color: color }} key={listValue.symbol}>
                    <td style={{ color: color }}><Link to={url}>{listValue.symbol}</Link></td>
                    <td>{parseFloat(listValue.price).toFixed(2)}</td>
                    <td>{parseFloat(listValue.changesPercentage).toFixed(2)}%</td>
                    <td ><Link style={{ color: color }} to={listValue.url}>{listValue.signal}</Link></td>
                </tr>
            )
        }
    }

    render() {
        let row;
        if (this.state.list === undefined || this.state.list.length <= 0) {
            row = <tr><td></td><td>No Data</td><td></td></tr>
        } else {
            row = this.state.list.map(this.renderRow.bind(this));
        }

        return (
            <Table bordered hover size="xs" style={{ fontSize: "10px" }}>
                <thead>
                    <tr>
                        <th>Ticker</th>
                        <th>Last</th>
                        <th>Change</th>
                        {/* <th><Link to={'/stocks/newLow'}>New Low</Link></th> */}
                        <th>Signal</th>
                    </tr>
                </thead>
                <tbody>
                    {row}
                </tbody>
            </Table>
        );
    }
}

export default MixLow;
